import { MainLoader, UnderConstructions } from 'src/components'

const DestinationsPage = () => {
  return (
    <MainLoader isLoading={false}>
      <div className='w-full h-full flex-center'>
        <UnderConstructions />
      </div>
    </MainLoader>
  )
}

export default DestinationsPage
